var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTriangleExclamation = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.0002 2C10.4595 2 10.8814 2.25313 11.1002 2.65625L17.8502 15.1562C18.0595 15.5437 18.0502 16.0125 17.8252 16.3906C17.6002 16.7688 17.1908 17 16.7502 17H3.25016C2.80953 17 2.40016 16.7688 2.17516 16.3906C1.95016 16.0125 1.94078 15.5437 2.15016 15.1562L8.90016 2.65625C9.11891 2.25313 9.54078 2 10.0002 2ZM10.0002 13C9.73494 13 9.48059 13.1054 9.29305 13.2929C9.10551 13.4804 9.00016 13.7348 9.00016 14C9.00016 14.2652 9.10551 14.5196 9.29305 14.7071C9.48059 14.8946 9.73494 15 10.0002 15C10.2654 15 10.5197 14.8946 10.7073 14.7071C10.8948 14.5196 11.0002 14.2652 11.0002 14C11.0002 13.7348 10.8948 13.4804 10.7073 13.2929C10.5197 13.1054 10.2654 13 10.0002 13ZM10.0002 7C9.43141 7 8.97828 7.48438 9.01891 8.05312L9.25016 11.3031C9.27828 11.6938 9.60641 12 9.99703 12C10.3908 12 10.7158 11.6969 10.7439 11.3031L10.9752 8.05312C11.0158 7.48438 10.5658 7 9.99391 7H10.0002Z",
  fill: "#F08C00"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTriangleExclamation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "fd49345c54d798cecd705c6067c5e87f.svg";